import { render, staticRenderFns } from "./interviewResult.vue?vue&type=template&id=72ead736&scoped=true&"
import script from "./interviewResult.vue?vue&type=script&lang=js&"
export * from "./interviewResult.vue?vue&type=script&lang=js&"
import style0 from "./interviewResult.vue?vue&type=style&index=0&id=72ead736&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ead736",
  null
  
)

export default component.exports